import {BoxTypeSelection, BoxTypeSelectionResult, PendingView, useBoxes, View, ViewContent} from "@variocube/cube-ui";
import * as React from "react";
import {useState} from "react";
import {stylesheet} from "typestyle";
import {getBoxTypes} from "@variocube/app-common";
import {CarrierViewHeader} from "./CarrierViewHeader";
import {useLocalization} from "../i18n";

interface SizeSelectionViewProps {
    onBack: () => void;
    onSelect: (result: BoxTypeSelectionResult) => void;
}

export function SizeSelectionView({onBack, onSelect}: SizeSelectionViewProps) {
    const [showPending, setShowPending] = useState(false);
    const {t} = useLocalization();
    const boxes = useBoxes();
    const types = getBoxTypes(boxes)
        .filter(type => ["S", "M", "L", "XL"].indexOf(type) >= 0);

    const handleSelect = (result: BoxTypeSelectionResult) => {
        setShowPending(true);
        onSelect(result);
    };

    if (showPending) {
        return <PendingView message={t("OccupyPending")}  />;
    }

    return (
        <View>
            <CarrierViewHeader
                onBack={onBack}
                title={t("SelectSizeTitle") as string}
                description={t("SelectSizeDescription") as string}
            />
            <ViewContent className={styles.viewContent}>
                <BoxTypeSelection
                    typeBoxDimensions={{
                        "S": { height: "13cm", width: "46cm", depth: "65cm" },
                        "M": { height: "28cm", width: "46cm", depth: "65cm" },
                        "L": { height: "43cm", width: "46cm", depth: "65cm" },
                        "XL": { height: "58cm", width: "46cm", depth: "65cm" }
                    }}
                    className={styles.selection}
                    strings={t}
                    onSelect={handleSelect}
                    types={types}
                />
            </ViewContent>
        </View>
    );
}

const styles = stylesheet({
    viewContent: {
        display: "flex"
    },
    selection: {
        flex: 1,
    }
});
